/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `draft` - 초안
 * `rendering` - 렌더링 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type ArrangementStatusEnum =
  (typeof ArrangementStatusEnum)[keyof typeof ArrangementStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArrangementStatusEnum = {
  draft: "draft",
  rendering: "rendering",
  completed: "completed",
  failed: "failed",
} as const;
